import { Component } from '@angular/core';
import { AlertController, IonicPage, LoadingController, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { UtilsProvider } from '../../providers/utils/utils';
import { CajaProvider } from '../../providers/caja/caja';
import { GESTION_PEDIDOS_SALON, MODO_DESCONECTADO, NUBE_AWS } from '../../config/url.servicio';
import { PushProvider } from '../../providers/push/push';
import { AppState } from '../../app/app.reducer';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';
import { Estados } from '../../models/estados/estados.models';
import * as fromClienteSelect from '../cliente-select/state/cliente-select/cliente-select-accions'
import * as fromUsuarioSelect from '../meseromesero/state/usuarioselect/usuarioselect.accions'
import * as fromClienteSelectAll from '../meseromesero/state/clienteselect/clienteselect.accions'
import * as fromEstados from '../meseromesero/state/estados/estados.accions'
import { valueDisplay } from '../../models/valueDisplay.model';
import { ClienteSelectPage } from '../cliente-select/cliente-select';
import { UsuarioSelectPage } from '../usuario-select/usuario-select';
import { AuthService } from '../../providers/auth-service';

declare var webkitSpeechRecognition: any;

@IonicPage()
@Component({
  selector: 'page-gestionar-pedido',
  templateUrl: 'gestionar-pedido.html',
  providers: [PushProvider,AuthService]
})
export class GestionarPedidoPage {
  listaProductosSeleccionados = []
  permiteEliminarPedido: boolean = false
  valorTotalVenta = 0
  infoResponse = []
  devolverVenta: boolean = false;
  mesaCambio = []
  mesasIdMesaCambio;
  turnosArray = [];
  domicilioSeleccionada: string = 'N'
  generarDomicilio: generarDomicilio[] = []
  valorTotalServicio:number= 0
  valorTotalProductos:number = 0
  valorTotalImpuestos:number = 0
  formasDePago: formasDePago[] = []
  formaPagoSeleccionada: string = 'O'
  CheckPorcentajeServicio:boolean = false
  porcentajeServicio:PorcentajeServicio[] = []
  datosAdicionales
  valorTotalDevolver = 0
  loader
  mesaSeleccionada
  price = 0
  subscriptionProductosSeleccionados: Subscription;
  porcentajeServicioValor: string = 'N'
  descripcionVenta: string = ''
  estado: Estados =  {
    clienteSelect: false,
    usuarioSelect: false,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }
  clienteId = []
  valoresCliente: string = '';
  usuarioId = [];
  valoresUsuario: string = '';
  imprimirProducto: boolean = true;
  imprimirGeneral: boolean = true;
  reconocimientoActivo: boolean = false;
  recognition: any;
  grabando: boolean = false;
  imprimirParcial: boolean = false;
  eliminarRegistroIndividual: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController,
              public utilsMensajero:UtilsProvider,
              public servicio: CajaProvider,
              public storage: Storage,
              public push:PushProvider,
              public loadingCtrl: LoadingController,
              public alertControllers: AlertController,
              private storePedidosSalon: Store<AppState>,
              public modalControllers: ModalController,
              public auth: AuthService,) {
    this.reconocimientoActivo = false
    this.generarDomicilio.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
    this.porcentajeServicio.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
    if(this.navParams.get('listaProductosSeleccionados')){
      this.permiteEliminarPedido = this.navParams.get('permiteEliminarPedido')
      // this.setupSubscription(this.listaProductosSeleccionados);
      this.listaProductosSeleccionados =   this.navParams.get('listaProductosSeleccionados')
      this.formaPagoSeleccionada =  this.listaProductosSeleccionados[0].formaDePago
      this.CheckPorcentajeServicio =  this.listaProductosSeleccionados[0].incluirServicio == 'S' ? true : false
      this.porcentajeServicioValor = this.listaProductosSeleccionados[0].incluirServicio
      this.domicilioSeleccionada = this.listaProductosSeleccionados[0].domicilio
      // let tempListaProductosSeleccionados =  this.listaProductosSeleccionados
      // this.listaProductosSeleccionados = []
      // this.listaProductosSeleccionados = tempListaProductosSeleccionados
      this.valorTotalVenta = this.navParams.get('valorTotalVenta')
      this.devolverVenta = this.navParams.get('devolverVenta')
      this.mesaSeleccionada = this.navParams.get('mesaSeleccionada')
      this.mesaCambio = this.navParams.get('mesaCambio')
      this.turnosArray = this.navParams.get('turnosArray')
      this.descripcionVenta =  this.navParams.get('descripcion')
      this.insertResponse('formaPagoSeleccionada', this.formaPagoSeleccionada)
      this.insertResponse('CheckPorcentajeServicio', this.CheckPorcentajeServicio)
      this.insertResponse('domicilioSeleccionada',  this.domicilioSeleccionada)
      this.calcularValorTotalVenta(null, 0, true)
      if(this.CheckPorcentajeServicio) {
        this.cambiarCheckPorcentaje()
      }
      this.listaProductosSeleccionados.forEach(elemento => {
        elemento.imprimirProducto = true
      });
    } else {
    }
    this.push.cualquiercosa('select codigoFormaPago, nombreFormaPago from formasDePago').subscribe((dataFormasDePago)=>{
      let valuesFormaDePago = []
      if(NUBE_AWS) {
        valuesFormaDePago =  JSON.parse(dataFormasDePago['_body']).data[0]
      } else {
        valuesFormaDePago = dataFormasDePago[0]
      }

      this.formaPagoSeleccionada = this.formaPagoSeleccionada // 'O'

      for(let y=0;y<valuesFormaDePago.length;y++){
          this.formasDePago.push({
              nombre:valuesFormaDePago[y].nombreFormaPago,
              valor:valuesFormaDePago[y].codigoFormaPago
           })
      }

    })
  }

  setupSubscription(listaProductosSeleccionados: any) {
    const objectObservable = Observable.from([listaProductosSeleccionados]);

    this.subscriptionProductosSeleccionados = objectObservable
      .distinctUntilChanged()
      .map((newObject: any) => {
        if(this.CheckPorcentajeServicio) {
          this.cambiarCheckPorcentajeSubscription(newObject)
        }
      })
      .subscribe();
  }

  cambiarCheckPorcentajeSubscription(listaProductosSeleccionados: any){



    let cantidad = listaProductosSeleccionados.length
    let valorProducto = 0
    let valorVenta = 0
    let valorImpuesto = 0
    listaProductosSeleccionados.forEach((data,item)=>{

      valorProducto+= data.valorVenta * data.cantidad
      valorVenta+= data.valorVenta
      valorImpuesto+= data.valorImpuesto * data.cantidad
      if(cantidad === item + 1){

        let porcentaje = valorProducto * 10 / 100
        let valorTotalServicio = porcentaje
        this.valorTotalVenta = valorProducto + valorImpuesto + valorTotalServicio
      }

    })

}

  insertResponse(name, value) {
    this.infoResponse.push({
    'name': name,
    'value': value
    })
  }

  validarDomicilio() {
    if(this.domicilioSeleccionada == null || this.domicilioSeleccionada == undefined) {
      this.insertResponse('domicilioSeleccionada',  'N')
    }
  }

  dismiss(){
    this.cerrarModal()
  }

  submit(){
    this.cerrarModal()
  }
  async eliminarMesa(){
    const uuids = this.listaProductosSeleccionados[0]['Uuid']
    const val = await this.storage.get('companiasId');
    this.utilsMensajero.mensajeConfirmacionDos('Borrar','¿Está Seguro de borrar los registros de el pedido?','question','Si','No')
    .then((borrar: boolean) => {
     if (borrar) {
        this.servicio.eliminarComandasPorCompanias(uuids, val).subscribe(() => {
        this.listaProductosSeleccionados = []
        this.insertResponse('buscarDatos', true)
        this.viewControllers.dismiss(this.infoResponse);
      })
     }else {
      this.utilsMensajero.mensajeMuestro('Borrar','No se elimiron los registros','Advertencia')
     }
   })
  }
  actualizarMesa(mesasIdMesaCambio?:any){
    this.utilsMensajero.mensajeMuestro('opción deshabilitada ','Esta opción está temporalmente deshabilitada','Advertencia')

    return
    this.storage.get('companiasId').then((val) => {
      let idmesanueva = this.mesaCambio[mesasIdMesaCambio].mesas
      let numeromesaActualizar =  this.listaProductosSeleccionados[0].numeromesa
      this.servicio.trasladarMesaPorCompaniaDomicilios(numeromesaActualizar, idmesanueva, val, this.turnosArray[0].turno)
        .subscribe((val) => {
          this.listaProductosSeleccionados = []
          this.insertResponse('buscarDatos', true)
          this.viewControllers.dismiss(this.infoResponse);
        }, (error) => {
          console.log(error)
        })
    })

  }
  buscarIdMesaActualizar(idmesa: any){

    let data = []

    let valorComparar = Number(idmesa)
    for (let k = 0; k < this.mesaCambio.length; k++) {
      if (k === valorComparar) {
        data.push({
          id: this.mesaCambio[k].mesas,
        })

      }
    }

    return data

  }
  cambioEnSeleccionDomicilio(data:string){
    this.domicilioSeleccionada = data
    this.insertResponse('domicilioSeleccionada',  this.domicilioSeleccionada)
  }

  valoresSelectPorcentaje(data:string){

    if(data['valor'] === "S"){
    this.cambiarCheckPorcentaje()
    this.insertResponse('CheckPorcentajeServicio', true)
    }else {
      this.calcularValorTotalVenta(null, 0, true)
      this.insertResponse('CheckPorcentajeServicio', false)
    }
  }

  cambiarCheckPorcentaje(){



          let cantidad = this.listaProductosSeleccionados.length
          let valorProducto = 0
          let valorVenta = 0
          let valorImpuesto = 0
          this.listaProductosSeleccionados.forEach((data,item)=>{

            valorProducto+= data.valorVenta * data.cantidad
            valorVenta+= data.valorVenta
            valorImpuesto+= data.valorImpuesto * data.cantidad
            if(cantidad === item + 1){

              let porcentaje = valorProducto * 10 / 100
              this.valorTotalServicio = porcentaje
              this.valorTotalVenta = valorProducto + valorImpuesto + this.valorTotalServicio
            }

          })

    }
    cambioEnSeleccionFormaDePago(data:string){
      this.formaPagoSeleccionada = data
      this.insertResponse('formaPagoSeleccionada',  this.formaPagoSeleccionada)
    }
    calcularValorTotalVenta(item: any, indexActual: any, queHago: boolean) {
      if(this.listaProductosSeleccionados.length> 0) {
        let valorTotalVentaJson: any = this.listaProductosSeleccionados.map((items: any, index: number) => {
          return {
              valorTotalVenta: Number(items.valorVenta) * Number(items.cantidad),
              valorGestionado: items.index === indexActual ? Number(items.valorVenta) : 0
              }
        })
      let valorTotalVenta = Object.keys(valorTotalVentaJson).map(function(key) {
          return valorTotalVentaJson[key].valorTotalVenta;
      });
      let valorTotalVentaReduce = valorTotalVenta.reduce((previous, current) => previous + current, 0);
      if(queHago) {
        this.valorTotalVenta = valorTotalVentaReduce
      }
      }
    }


    async pagarmesas(){
      this.insertResponse('buscarDatos', true)
      let VentaUuid = require('uuid/v4');
      // hacer validaciones para finalizar la venta
      this.datosAdicionales = {
        valorTotalVenta: 0,
        // totalPagado: this.valorTotalDevolver,
        totalPagado: 0,
        // valorTotalDevolver: (this.valorTotalDevolver - this.valorTotalVenta),
        valorTotalDevolver: 0,
        usuariosId: 0,
        companiasId: 0,
        clientesId: 0,
        turno:0,
        comandasId: 0,
        ventaDiariaUuid: VentaUuid()
    };

      this.datosAdicionales['totalPagado'] = 0
      this.datosAdicionales['totalPagado'] = this.valorTotalDevolver
      let valorTotalVentaValidar: number = Number(this.valorTotalDevolver) - Number(this.valorTotalVenta)
      if( valorTotalVentaValidar < 0 ){
      // || isNaN(this.valorTotalDevolver) || (this.datosAdicionales['totalPagado']===0) ){
      // this.mostrarMensajeDeError('Valor a devolver no valido!')
          console.log(`Valor a devolver no valido!`)
          return
      } else if ( this.valorTotalVenta < 0){
          console.log(`Valor total venta no valido!`)
          return
      }
      this.datosAdicionales['valorTotalDevolver'] = valorTotalVentaValidar
      this.datosAdicionales['valorTotalVenta'] = Number(this.valorTotalVenta)

      this.getMultiple(['usuariosId','companiasId'])
      .then(async res => {

          // mostrar cargando
          this.loader = this.loadingCtrl.create({});
          this.loader.present();

          let busquedaGestion = 'G'
          let valoreslistaProductosSeleccionados = []
          valoreslistaProductosSeleccionados = this.listaProductosSeleccionados[0]

          let codigo = valoreslistaProductosSeleccionados['codigo']
          let clienteCaja = await this.buscarClienteStore();

          if (clienteCaja['valuedisplay'] !== undefined && clienteCaja['valuedisplay'][0] !== undefined && clienteCaja['valuedisplay'][0].value !== undefined) {
            // envia el cliente que este seleccionado
            this.datosAdicionales['clientesId'] = clienteCaja['valuedisplay'][0].value
          }
          if(!this.CheckPorcentajeServicio && this.datosAdicionales['clientesId'] == 0){
            this.datosAdicionales['clientesId'] = 1
          }
          if(this.datosAdicionales['clientesId'] == 0 && this.formaPagoSeleccionada == 'C') {
            console.log(`Para generar una cuenta por cobrar debe asignar un cliente','Advertencia`)
            return
          }

          this.datosAdicionales['tipoVenta'] = this.formaPagoSeleccionada
          let cantidadActual = this.listaProductosSeleccionados.length
          this.datosAdicionales['servicio'] = this.listaProductosSeleccionados[0].incluirServicio == 'S' ? this.listaProductosSeleccionados[0].incluirServicio : 'N'

          this.datosAdicionales['usuariosId'] = res['usuariosId']
          this.datosAdicionales['companiasId'] = res['companiasId']

          if(this.datosAdicionales['usuariosId']==null){
            this.datosAdicionales['usuariosId'] = 1
          }

          if(codigo !== undefined) {
          this.servicio.buscarComandasFacturaPorCompania(codigo)
          .subscribe((data)=>{
              if(NUBE_AWS) {
                data = JSON.parse(data['_body']).data[0]
              }
              let cantidadReal = data.length
              if(cantidadReal == cantidadActual){
                this.generarVenta()
              }else{
                this.comandaNoValida()
              }
          },(error)=> console.log(error))
         } else {
          this.generarVentaSinGestion()
         }
      })


  }

  generarVenta() {
    let listaProductosSeleccionadosNuevosValores = this.refactorizarValoresMesas(this.listaProductosSeleccionados)
                  this.storage.get('fechaSistema').then(async (val) => {

                      if(val!=undefined){
                          this.datosAdicionales['fechaVenta'] = val
                      }
                      let elaboradosContenido = ''
                      let turno = undefined
                      let comandasId = undefined
                      if(this.datosAdicionales.turno != undefined && this.datosAdicionales.turno > 0) {
                        turno = this.datosAdicionales.turno
                        comandasId =  this.datosAdicionales.comandasId
                      }
                      if(comandasId == undefined){
                        let cuantosLista = listaProductosSeleccionadosNuevosValores.length - 1
                        comandasId = listaProductosSeleccionadosNuevosValores[cuantosLista].comandasId
                        this.datosAdicionales['comandasId'] =comandasId
                      }
                      if(this.datosAdicionales['turno'] == 0) {
                        this.datosAdicionales['turno'] =this.turnosArray[0].turno
                      }
                      this.datosAdicionales['codigo'] = listaProductosSeleccionadosNuevosValores[0].codigo
                      let usuarioIngreso = await this.storage.get('usuariosId');
                      let usuarioId = usuarioIngreso;
                      if(usuarioId) {
                        this.datosAdicionales['usuariosId'] = usuarioId
                      }
                      this.servicio.guardarVenta(listaProductosSeleccionadosNuevosValores, this.datosAdicionales,elaboradosContenido,'').subscribe(
                          resVenta => {
                              this.loader.dismiss()
                                  for(var k =0;k < listaProductosSeleccionadosNuevosValores.length;k++){
                                      if(this.mesaSeleccionada == listaProductosSeleccionadosNuevosValores[k].numeromesa){
                                          let datosComanda = {
                                              comandasId: listaProductosSeleccionadosNuevosValores[k].comandasId,
                                              estado: 'F',
                                              imagen: null,
                                              color: '#006400',
                                              queHago: "A",
                                              nombreTabla: "comandas",
                                              name: "dataDynamicCrud"
                                             }
                                            this.servicio.actualizarComandas(datosComanda)
                                            .subscribe((data)=>{
                                            },(error)=>{
                                              console.log('error actualizarComandas', error)
                                            })
                                      } else {
                                        if(this.mesaSeleccionada == turno && listaProductosSeleccionadosNuevosValores[k].comandasId === comandasId){
                                          let consecutivo = JSON.parse(resVenta['_body']).data[0]
                                          let numeroFactura: string = ''; // Variable donde se guardará el número de factura
                                            consecutivo.forEach(item => {
                                            if (item.reciboCaja.includes("Factura de Venta Nro:")) {
                                              // Extraer el número de factura
                                              const regex = /Factura de Venta Nro: (\d+)/;
                                              const match = item.reciboCaja.match(regex);
                                              if (match) {
                                                  numeroFactura = match[1]; // El número de factura se guarda en la variable
                                              }
                                          }})
                                            this.servicio.ActualizarComandasPorTurno(this.datosAdicionales.companiasId,turno,numeroFactura)
                                            .subscribe((data)=>{
                                            },(error)=>{
                                            })
                                      }
                                      }
                                  }
                            let dataJson = JSON.parse(resVenta['_body'])
                            let mensaje = dataJson
                             this.mostrarMensajeGeneral(dataJson)
                             this.imprimirMesero(listaProductosSeleccionadosNuevosValores[0].codigo)
                             this.cerrarModalVentaGenerada()

                          },
                          errVenta => {
                            console.log('error errVenta', errVenta)
                              this.loader.dismiss()

                          }
                      )
                  });
  }


  generarVentaSinGestion() {
      this.storage.get('fechaSistema').then((val) => {

          if(val!=undefined){
              this.datosAdicionales['fechaVenta'] = val
          }
          let elaboradosContenido = ''
          let turno = undefined
          let comandasId = undefined
          if(this.datosAdicionales.turno != undefined && this.datosAdicionales.turno > 0) {
            turno = this.datosAdicionales.turno
            comandasId =  this.datosAdicionales.comandasId
          }
          if(comandasId == undefined){
            let cuantosLista = this.listaProductosSeleccionados.length - 1
            comandasId = this.listaProductosSeleccionados[cuantosLista].comandasId
            this.datosAdicionales['comandasId'] =comandasId
          }
          if(this.datosAdicionales['turno'] == 0) {
            this.datosAdicionales['turno'] =this.turnosArray[0].turno
          }
          this.servicio.guardarVenta(this.listaProductosSeleccionados, this.datosAdicionales,elaboradosContenido,'').subscribe(
              resVenta => {
                  this.loader.dismiss()
                  let dataJson = JSON.parse(resVenta['_body'])
                  let mensaje = dataJson
                  // this.mostrarMensajeGeneral(mensaje)
                  let recibo = ''
                  let mensajes = NUBE_AWS ? Object.keys(mensaje).map(key => mensaje[key]) : mensaje[0]
                  for (let index:any = 0; index < mensajes.length; index++) {

                      recibo += mensajes[index]['reciboCaja'] + '\n'
                      // reciboBlue +=   `{"reciboCaja":"${mensajes[index]['reciboCaja']}"},`;
                  }

                  this.imprimirRecibo(recibo)
                  this.cerrarModalVentaGenerada()

              },
              errVenta => {
                console.log('error errVenta', errVenta)
                  this.loader.dismiss()

              }
          )
      });
  }
  getMultiple(keys: string[]) {
    const promises = [];

    keys.forEach( key => promises.push(this.storage.get(key)) );

    return Promise.all(promises).then( values => {
      const result = {};

      values.map( (value, index) => {
        result[keys[index]] = value;
      });

      return result;
    });
}
comandaNoValida(){
  this.loader.dismiss()
  this.alertControllers.create({
      title:'Advertencia',
      message: 'No puede guardar la venta por que existen productos que no estan gestionados',
      buttons: ['ok']
}).present()
}
async buscarClienteStore() {
  return new Promise((resolve, reject) => {
     this.storePedidosSalon.select('clienteSelect').subscribe((clientecaja) => {
       return resolve(clientecaja)
     })
   });
 }

 refactorizarValoresMesas(data:any){
  this.listaProductosSeleccionados = []

  for(let i=0;i <data.length;i++){

      this.listaProductosSeleccionados.push({
          productosId:Number(data[i].productosId),
          tipoProducto:data[i].tipoProducto,
          cantidad:Number(data[i].cantidad),
          valorProducto: data[i].valorProductoIndividual == undefined ? Number(data[i].valorVenta) : Number(data[i].valorProductoIndividual),
          valorImpuesto: data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
          ubicacionesPorSalonesId:data[i].ubicacionesPorSalonesId,
          valorTotalImpuestos : data[i].valorImpuestoIndividual == undefined ? Number(data[i].valorImpuesto) : Number(data[i].valorImpuestoIndividual),
          valorTotalVenta : Number(data[i].valorTotalVenta),
          valorTotalProductos :  data[i].valorProductoIndividual == undefined ? Number(data[i].valorProducto) : Number(data[i].valorProductoIndividual),
          valorTotalDevolver: Number(data[i].valorTotalVenta),
          clienteId: data[i].clientesId,
          valormesa: data[i].numeromesa,
          comandasId: Number(data[i].comandasId),
          numeromesa:data[i].numeromesa,
          codigo:data[i].codigo,
          valorImpuestoCalculo: data[i].valorImpuestoCalculo,

      });
  }
  return this.listaProductosSeleccionados
}
mostrarMensajeGeneral(mensaje) {
  let recibo = ''
  let reciboBlue = ''
  let nuevovalorjsonBlue = ''
  if(MODO_DESCONECTADO){
      for (let index:any = 0; index < mensaje.length; index++) {
          recibo += mensaje[index]['reciboCaja'] + '\n'
      }
  }else{
      let newMensaje = NUBE_AWS ? mensaje : mensaje[0];
      if(newMensaje){

          let mensajes = NUBE_AWS ? Object.keys(mensaje).map(key => mensaje[key]) : mensaje[0]
          let recorrerMensaje = mensajes[0] !== undefined && mensajes[0][0] !== undefined ? mensajes[0] : mensajes
          for (let index:any = 0; index < recorrerMensaje.length; index++) {

              recibo += recorrerMensaje[index]['reciboCaja'] + '\n'
              reciboBlue +=   `{"reciboCaja":"${recorrerMensaje[index]['reciboCaja']}"},`;
          }

          var jsoncadena = reciboBlue;
          jsoncadena = jsoncadena.substr(jsoncadena.length - 1, 1) == ',' ? jsoncadena.substring(0, jsoncadena.length - 1) : jsoncadena;
          nuevovalorjsonBlue =  "[" + jsoncadena + "]";
     }
  }
}
imprimirMesero(codigo:any){

    this.storage.get('companiasId').then((val) => {
    let codigoNuevo = typeof codigo === "string" ? codigo : codigo[0].codigo
    this.servicio.imprimirComandasMesas(codigoNuevo,val)
    .subscribe((data)=>{
      let dataJson = JSON.parse(data['_body'])
      let responseJson = dataJson
      this.reemprimirRecibo(responseJson)
    },
     error=>{
       console.log(error)
     })
    })
}

imprimirMeseroParcial(){
  this.insertResponse('imprimirParcial', true)
  this.cerrarModal()
}




iniciarReconocimiento() {
  if (!this.reconocimientoActivo) {
    this.recognition = new webkitSpeechRecognition();
    this.recognition.onresult = (event) => {
      this.descripcionVenta = event.results[0][0].transcript;
    };
    this.recognition.start();
    this.reconocimientoActivo = true;
    this.grabando = true;
  }
}

detenerReconocimiento() {
  if (this.reconocimientoActivo) {
    this.recognition.stop();
    this.reconocimientoActivo = false;
    this.grabando = false; // Establecer a false cuando se detiene la grabación
    // this.detenido = true; // Establecer a true cuando se detiene la grabación
  }
}

imprimirRecibo(recibo: any) {
  this.servicio.imprimirRecibo(recibo).subscribe(
    res => {

    },
    err => {
     console.log(`${recibo}`)
    }
)
}

reemprimirRecibo(mensaje) {
  let recibo = ''


  if(MODO_DESCONECTADO){
      for (let index:any = 0; index < mensaje.length; index++) {
          recibo += mensaje[index]['reciboCaja'] + '\n'
      }
  }else{
      if(mensaje.data && mensaje.data[0] && mensaje.data[0][0]){
          let mensajes = mensaje.data[0]
          for (let index:any = 0; index < mensajes.length; index++) {
              recibo += mensajes[index]['reciboCaja'] + '\n'
          }
      }
  }


  // mandar a imprimir
  this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {

              console.log(`${recibo}`)


      }
  )


}
seleccionarTodo(ev) {
  if(ev && ev['target'] && ev.target['select']){
      ev.target.select();
  }
}
DECIMAL_SEPARATOR  = '.'
GROUP_SEPARATOR = ','

format(valString) {
    if (!valString) {
        this.valorTotalDevolver = 0
        return '';
    }
    let val = valString.toString();
    try {
        this.valorTotalDevolver = Number(val.replace(/,/g, ''))
    } catch (e) {
        this.valorTotalDevolver = 0
    }

    const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
    return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
};

unFormat(val) {
    if (!val) {
        return '';
    }
    val = val.replace(/^0+/, '');

    if (this.GROUP_SEPARATOR === ',') {
        return val.replace(/,/g, '');
    } else {
        return val.replace(/\./g, '');
    }
};

cerrarModalVentaGenerada() {
  this.cerrarModal()
}

cerrarModal() {
  this.insertResponse('descripcionVenta', this.descripcionVenta)
  this.insertResponse('clienteId', this.clienteId)
  this.insertResponse('usuarioId', this.usuarioId)
  this.validarDomicilio()
  if(this.listaProductosSeleccionados.length>0) {
    this.insertResponse('listaProductosSeleccionados', this.listaProductosSeleccionados)
  }
  this.insertResponse('imprimirGeneral', this.imprimirGeneral)
  this.insertResponse('eliminarRegistroIndividual', this.eliminarRegistroIndividual)
  this.viewControllers.dismiss(this.infoResponse);
}

enviarcomanda() {
  this.insertResponse('enviarcomanda', true)
  this.cerrarModal()
}

async buscarClienteSelect() {
  this.estado = {
    clienteSelect: true,
    usuarioSelect: false,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }

  this.actualizarestados(this.estado)
  const modal = await this.modalControllers.create(ClienteSelectPage);
  await modal.present();
  modal.onDidDismiss(data => {
    this.estado = {
      clienteSelect: false,
      usuarioSelect: false,
      grupos: true,
      productos: false,
      pedidos: false,
      mesas: false,
      response: false
    }
    this.actualizarestados(this.estado)
    if (data) {
      this.clienteId.push({value:data.value, display:data.display})
      let cliente: valueDisplay[] = [{
        value:data.value,
        display:data.display
      }]
      const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
      this.storePedidosSalon.dispatch(actionClienteCaja);
      this.valoresCliente = data.display;
    }
  })
}

actualizarestados(estado: Estados) {
  let estados:any = {
    ...estado
  }
  let estadosAction = new fromEstados.SetEstadosAction(estados)
  this.storePedidosSalon.dispatch(estadosAction)
}

async buscarUsuarioSelectPage() {

  this.actualizarestados(this.estado)
  const modal = await this.modalControllers.create(UsuarioSelectPage, {data: [],consultarUsuario: true});
  await modal.present();
  modal.onDidDismiss(data => {
    if (data != undefined && data.value != undefined) {
      this.usuarioId.push({value:data.value, display:data.display})
      let usuario: valueDisplay[] = [{
        value:data.value,
        display:data.display
      }]
      const actionUsuario = new fromUsuarioSelect.CargarValueDisplaySuccessActions(usuario);
      this.storePedidosSalon.dispatch(actionUsuario);
      this.valoresUsuario = data.display;
    }
  })
}

ImprimirGeneral() {
}

seleccionarElementoCheck(elemento: any, index: any) {
  this.listaProductosSeleccionados[index].color = '#1E078E'
 }
 eliminarUnRegistro(elemento: any, index: any) {
  let actualizarValorTotalVenta =  Number(elemento.valorVenta) * Number(elemento.cantidad)
  this.presentPromp(elemento,index,actualizarValorTotalVenta)

 }

 presentPromp(elemento: any, index: any,actualizarValorTotalVenta:any){

  let alert = this.alertControllers.create({
    title: 'Ingreses sus credenciales para autorizar eliminar el registro',
    inputs: [
      {
        name: 'usuario',
        placeholder: 'Usurio'
      },
      {
        name: 'clave',
        placeholder: 'Clave',
        type: 'password'
      }
    ],
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        handler: data => {
          console.log('cancel', data)
        }
      },
      {
        text: 'Aceptar',
        handler: data => {
          try {
            let credenciales = {
              usuario: data.usuario,
              clave: data.clave
            }

            this.auth.login(credenciales).subscribe(
              async (res) => {
                if (res !== undefined && res.error !== undefined && res.error === 500) {
                  var message = res.mensaje
                  this.utilsMensajero.mensajeMuestro(message,'Verifique...','error')
                  return
                }


                  res = res.response == undefined ? [] : res.response
                  if(res.length==0) {
                    this.utilsMensajero.mensajeMuestro('Los datos ingresados no son validos','Verifique...','error')
                    return
                  }

                  if(res.length>0 && res[0].admin){
                    this.servicio.eliminarComandasRegistroIndividualPorCompanias(elemento.comandasId,res[0].usuariosId,elemento.companiasId)
                    .subscribe((data)=>{
                      this.eliminarRegistroIndividual = true
                      let dataJson = JSON.parse(data['_body'])
                      let responseJson = dataJson
                      console.log('resonse', responseJson)
                      this.listaProductosSeleccionados.splice(index, 1);
                      this.listaProductosSeleccionados.forEach(registro => {
                        registro.valorTotalVenta -= actualizarValorTotalVenta;
                      });
                      this.cerrarModal()
                    },
                     error=>{
                       console.log(error)
                     })

                    }else{
                      this.utilsMensajero.mensajeMuestro('Autorización','Los datos ingresados no son validos','Advertencia')
                    }


              },
              error => {
                var message = JSON.parse(error['_body'])
                this.utilsMensajero.mensajeMuestro(message['message'],'Verifique...','error')
              }
            )

          } catch (error) {
            this.utilsMensajero.mensajeMuestro(error['message'],'Verifique...','error')
            console.log(error);
          }
        }
      }
    ]
  });
  alert.present();

}

}

class generarDomicilio {
  public nombre:string;
  public valor:string;
}

class formasDePago {
  public nombre:string;
  public valor:string;
}
class PorcentajeServicio {
  public nombre:string;
  public valor:string;
}



// WEBPACK FOOTER //
// ./src/pages/gestionar-pedido/gestionar-pedido.ts